import css from '../../../utils/css';

export default css`
  :host {
    --widget-font-family: 'Ariana Pro', sans-serif;

    --tsn-black: #080707;
    --tsn-white: #ffffff;
    --tsn-red: #e8262c;
    --tsn-nickel-gray: #7d7d7d;
    --tsn-light-gray: #ebebeb;

    --widget-background-color: var(--tsn-white);
    --widget-text-color: var(--tsn-black);
    --widget-subtext-color: #9d9da3;
    --widget-border-color: var(--tsn-nickel-gray);
    --widget-divider-color: var(--tsn-light-gray);

    --widget-header-bg-color: var(--tsn-black);
    --widget-header-text-color: var(--tsn-white);
    --widget-header-odds-bg-color: var(--tsn-light-gray);
    --widget-header-odds-shadow: #ccc;

    --widget-mobile-seeall-color: var(--tsn-red);

    --widget-grid-odds-text-color: var(--tsn-black);

    --widget-grid-best-odds-bg-color: var(--tsn-nickel-gray);
    --widget-grid-best-odds-border-color: transparent;
    --widget-grid-best-odds-text-color: var(--tsn-white);

    --widget-grid-compare-active-bg-color: var(--tsn-light-gray);
    --widget-grid-compare-color: var(--tsn-nickel-gray);

    --widget-grid-ribbon-bg-color: var(--tsn-red);
    --widget-grid-ribbon-color: var(--tsn-white);
  }
`;
